// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Specials/style.css
 ** module id = 1577
 ** module chunks = 0
 **/